// extracted by mini-css-extract-plugin
export var textBlock = "styles-module--textBlock--h09zV";
export var paragraph = "styles-module--paragraph--QFfSK";